<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['common.status']">
              <!--<a-select v-model="queryParam.isResigned" placeholder="请选择" allowClear>
                <a-select-option value="0">否</a-select-option>
                <a-select-option value="1">是</a-select-option>
              </a-select>-->
              <j-dict-select-tag v-model="queryParam.status"  dictCode="depart_move_status" allowClear/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['depart.management.departName']">
              <!--<a-select v-model="queryParam.isResigned" placeholder="请选择" allowClear>
                <a-select-option value="0">否</a-select-option>
                <a-select-option value="1">是</a-select-option>
              </a-select>-->
              <a-input  v-model="queryParam.departName" allowClear></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!--<a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('sys_depart_move')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <!-- 高级查询区域 -->
      <!--<j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>-->
      <!--<a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"

        class="j-table-force-nowrap"
        @change="handleTableChange"><!--:rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"-->

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{language['common.noPicture']}}</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{language['common.noFile']}}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{language['download']}}
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)" v-if="record.status === '1'">{{language['common.edit']}}</a>
            <a-divider type="vertical" v-if="record.status === '1'"/>
            <a @click="transferDepart(record.id)" v-if="record.status === '1'">{{language['depart.moveBtn']}}</a>
            <a-divider type="vertical" v-if="record.status === '1'"/>
            <a @click="cancel(record.id)" v-if="record.status === '1'">{{language['common.cancel']}}</a>
            <a @click="handleDetail(record)" v-if="record.status !== '1'">{{language['common.look']}}</a>

          <!--<a-divider type="vertical" />-->
          <!--<a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>-->
        </span>

      </a-table>
    </div>

    <sys-depart-move-modal ref="modalForm" @ok="modalFormOk"></sys-depart-move-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SysDepartMoveModal from './modules/SysDepartMoveModal'
  import { httpAction } from '@/api/manage'

  export default {
    name: 'SysDepartMoveList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      SysDepartMoveModal
    },
    data () {
      return {
        description: 'sys_depart_move管理页面',
        queryParam: {},
        // 表头

        url: {
          list: "/sys/sysDepartMove/list",
          delete: "/sys/sysDepartMove/delete",
          deleteBatch: "/sys/sysDepartMove/deleteBatch",
          exportXlsUrl: "/sys/sysDepartMove/exportXls",
          importExcelUrl: "/sys/sysDepartMove/importExcel",
          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    // this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language(){
        return this.$store.getters.language;
      },
      columns(){
        if(this.language){
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.language['depart.management.departName'],
              align:"center",
              dataIndex: 'departName'
            },
            {
              title:this.language['depart.management.oldFDepart'],
              align:"center",
              dataIndex: 'oldDepartName'
            },
            {
              title:this.language['depart.management.oldFDepartNo'],
              align:"center",
              dataIndex: 'oldDepartNo'
            },
            {
              title:this.language['depart.management.newFDepart'],
              align:"center",
              dataIndex: 'newDepartName'
            },
            {
              title:this.language['depart.management.newFDepartNo'],
              align:"center",
              dataIndex: 'newDepartNo'
            },
            {
              title:this.language['system.effectiveDate'],
              align:"center",
              dataIndex: 'effectiveDate',
              customRender:function (text) {
                return !text?"":(text.length>10?text.substr(0,10):text)
              }
            },
            {
              title:this.language['depart.moveBtn']+this.language['common.status'],
              align:"center",
              dataIndex: 'status_dictText'
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' }
            }
          ]
        }
      }

    },
    methods: {
      handleDetail:function(record){
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title=this.language["common.detailsButton"];
        this.$refs.modalForm.disableSubmit = true;
      },
      handleEdit: function (record) {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = this.language["common.edit"]
        this.$refs.modalForm.disableSubmit = false;
      },
      initDictConfig(){
      },
      /*getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'oldDepartId',text:'旧部门id'})
        fieldList.push({type:'string',value:'newDepartId',text:'新部门id'})
        fieldList.push({type:'date',value:'effectiveDate',text:'生效日期'})
        fieldList.push({type:'string',value:'status',text:'迁移状态'})
        this.superFieldList = fieldList
      },*/
      transferDepart(id){
        this.$confirm({
          title: this.language["confirm.titleConfirmOperation"],
          content: this.language['common.whether']+this.language['common.determineButton']+this.language["depart.moveBtn"],
          onOk: function () {
            httpAction('/sys/sysDepart/transferDepartRightNow?id='+id,'','get').then((res)=>{
              if(res.success){
                this.$message.success(res.message);
              }else{
                this.$message.warning(res.message);
              }
              // this.searchQuery()
              this.loadData(1)
            })
          }
        })
      },
      cancel(id){
        this.$confirm({
          title: this.language['system,cancel.warn'],
          content: '',
          onOk: function () {
            httpAction('/sys/sysDepartMove/cancel?id='+id,'','get').then((res)=>{
              if(res.success){
                this.$message.success(res.message);
              }else{
                this.$message.warning(res.message);
              }
              // this.searchQuery()
              this.loadData(1)
            })
          }
        })
      },

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>